import axios from "axios";
import api from "../../../../../services/axios";

export const ConvertToDeal = async (payload) => {
  try {
    const res = await api.post("/Employee/Deal/ConvertLeadToDeal", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const GetMyDeals = async (chunkNumber, searchF) => {
  try {
    const res = await api.get(`/Employee/Deal/GetMyDeals?chunkNumber=${chunkNumber}&searchF=${searchF}`);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const ShortlistCandidate = async (payload) => {
  try {
    const res = await api.post("/Employee/Deal/ShortlistCandidate", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const RejectCandidate = async (payload) => {
  try {
    const res = await api.post("/Employee/Deal/RejectCandidate", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const BackoutCandidate = async (payload) => {
  try {
    const res = await api.post("/Employee/Deal/BackoutCandidate", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const SheduleInterview = async (payload) => {
  try {
    const res = await api.post("/Employee/Deal/SheduleInterview", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const SelectCandidate = async (payload) => {
  try {
    const res = await api.post("/Employee/Deal/SelectCandidate", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const MoveCandidateToBGV = async (payload) => {
  try {
    const res = await api.post("/Employee/Deal/MoveCandidateToBGV", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const ReleaseCandidateOffer = async (payload) => {
  try {
    const res = await api.post("/Employee/Deal/ReleaseCandidateOffer", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const HireCandidate = async (payload) => {
  try {
    const res = await api.post("/Employee/Deal/HireCandidate", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const GetDealHistory = async (dealUID) => {
  try {
    const res = await api.get(`/Employee/Deal/DealHistory?dealUID=${dealUID}`);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};